import React from 'react'

import DefaultHeaderMeta from 'features/core/DefaultHeaderMeta'
import { CenterPanel, CenterPanelWrapper } from 'features/studio/ui/Layout'
import { Heading, Icon8, Section, Text } from 'legacy/v1/ui'

const ErrorPage = () => {
    return (
        <>
            <DefaultHeaderMeta title="Error" />
            <CenterPanelWrapper hidePoweredBy>
                <CenterPanel>
                    <ErrorComponent />
                </CenterPanel>
            </CenterPanelWrapper>
        </>
    )
}

const ErrorComponent = () => {
    const studioToken = localStorage.getItem('studio_token')
    return (
        <Section centered style={{ marginBottom: '30px' }}>
            <Icon8
                icon="sad-cloud"
                iconStyle="material-outlined"
                displaySize="200"
                color="333333"
                noMargin
            />
            <Heading size="medium">Something went wrong</Heading>
            <Text style={{ maxWidth: '300px', textAlign: 'center' }}>
                Sorry, an unrecoverable error occurred.
            </Text>
            {studioToken && (
                <Text style={{ maxWidth: '300px', textAlign: 'center' }}>
                    Please get in touch with Stacker support and we&apos;ll be able to help.
                </Text>
            )}
        </Section>
    )
}

export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { caughtError: false }
    }

    // We keep the error in argument here because it is standard React practice
    // eslint-disable-next-line unused-imports/no-unused-vars
    static getDerivedStateFromError(error) {
        return { caughtError: true }
    }

    render() {
        if (this.state.caughtError) {
            return this.props.app ? <ErrorPage /> : <ErrorComponent />
        }

        return this.props.children
    }
}

export const catchAppErrors = (children) => <ErrorBoundary app>{children}</ErrorBoundary>

export const catchComponentErrors = (children) => <ErrorBoundary>{children}</ErrorBoundary>
